import React from "react";
import { Card, CardHeader, CardBody, CardTitle, Row, Col } from "reactstrap";

// Page shell for the garage forms reached by a direct link instead of a dialog.
const FormPage = ({ title, subtitle, children }) => (
  <div className="content mform-page">
    <Row>
      <Col md="12">
        <Card>
          <CardHeader>
            <CardTitle tag="h4">{title}</CardTitle>
            {subtitle && <span className="mmodal__subtitle">{subtitle}</span>}
          </CardHeader>
          <CardBody>{children}</CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

export default FormPage;
